import moment from "moment";

export const day = (value, mask) => {
	if (!value) return ''
	
	if( !!mask ){
		return typeof value ? moment(String(value), mask).format('dddd') : value;
	} else {
		return typeof value ? moment(String(value)).format('dddd') : value;
	}
};
